// extracted by mini-css-extract-plugin
module.exports = {"products":"js-z","misad":"ks-z","oosMessaging":"ls-z","topProductFrame":"ms-z","productCardOverrides":"ns-z","secondRowAds":"os-z","microsoftAdsWrapper":"ps-z"};